
import type { RouteObject } from 'react-router-dom';
import { lazy } from 'react';

const Home = lazy(() => import('../pages/home/page'));
const About = lazy(() => import('../pages/about/page'));
const Blog = lazy(() => import('../pages/blog/page'));
const BlogArticle = lazy(() => import('../pages/blog/article/page'));
const BlogArticleIronGlass = lazy(() => import('../pages/blog/article-iron-glass/page'));
const BlogArticleMaintenance = lazy(() => import('../pages/blog/article-maintenance/page'));
const BlogArticleTrends = lazy(() => import('../pages/blog/article-trends/page'));
const BlogArticleGlass = lazy(() => import('../pages/blog/article-glass/page'));
const BlogArticleTips = lazy(() => import('../pages/blog/article-tips/page'));
const BlogArticleFuture = lazy(() => import('../pages/blog/article-future/page'));
const BlogArticleCertifications = lazy(() => import('../pages/blog/article-certifications/page'));
const BlogArticleDiscreta = lazy(() => import('../pages/blog/article-discreta/page'));
const PrivacyPolicy = lazy(() => import('../pages/privacy/page'));
const TermsOfUse = lazy(() => import('../pages/terms/page'));
const NotFound = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <Home />
  },
  {
    path: '/sobre-nos',
    element: <About />
  },
  {
    path: '/blog',
    element: <Blog />
  },
  {
    path: '/blog/artigo/novas-tecnologias-blindagem-2024',
    element: <BlogArticle />
  },
  {
    path: '/blog/artigo/iron-glass-vs-iron-glass-plus',
    element: <BlogArticleIronGlass />
  },
  {
    path: '/blog/artigo/manutencao-veiculos-blindados',
    element: <BlogArticleMaintenance />
  },
  {
    path: '/blog/artigo/tendencias-seguranca-automotiva-premium',
    element: <BlogArticleTrends />
  },
  {
    path: '/blog/artigo/vidros-blindados-tecnologia-transparencia',
    element: <BlogArticleGlass />
  },
  {
    path: '/blog/artigo/10-dicas-seguranca-veiculos-blindados',
    element: <BlogArticleTips />
  },
  {
    path: '/blog/artigo/futuro-blindagem-nanotecnologia',
    element: <BlogArticleFuture />
  },
  {
    path: '/blog/artigo/certificacoes-internacionais-blindagem',
    element: <BlogArticleCertifications />
  },
  {
    path: '/blog/artigo/blindagem-discreta-protecao-invisivel',
    element: <BlogArticleDiscreta />
  },
  {
    path: '/politica-de-privacidade',
    element: <PrivacyPolicy />
  },
  {
    path: '/termos-de-uso',
    element: <TermsOfUse />
  },
  {
    path: '*',
    element: <NotFound />
  }
];

export default routes;
